import { graphql } from '@/generated/gql';

export const QUOTE_SOURCING_CASE_NEGOTIATION_SETTINGS_QUERY = graphql(/* GraphQL */ `
  query QuoteSourcingCaseNegotiationSettingsQuery($id: UUID!) {
    tesseract {
      negotiationCase(id: $id) {
        id
        isNegotiationEnabled
        isSupplierUploadAllowed
        status
        processStatus
        supplier {
          id
          internalId
        }
        lowerDiscountBoundary
        upperDiscountBoundary
        strategy {
          id
          useHistoricTenderData
          useHistoricNegotiationData
          boundaryRules {
            id
            base
            lower
            upper
            sequence
          }
        }
        options {
          id
          initiatedBy
          quoteMode
          negotiationMode
          supplierInteractionMode
          negotiationObjective
        }
        demand {
          id
        }
        negotiatedQuote {
          id
          currency
          discount
          totalValue
          totalDiscountedValue
          totalPriceDiscount
          createdAt
        }
      }
    }
  }
`);
